/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getRequestTimerSettings } from "api/services/quoteRequest";
import { quoteRequestQueryKeys } from "./quoteRequestQueryKeys";

type TimingSettings = {
  use_default_confirmation_time: boolean;
  quoting_deadline_minimum_time_minutes: number;
  default_confirmation_time_days: number;
};

export const useGetQuoteRequestTimerSettings = (options: UseQueryOptions<TimingSettings>) =>
  useQuery({
    queryKey: quoteRequestQueryKeys.quoteTimerSettings(),
    queryFn: () => getRequestTimerSettings().then((res) => res.data),
    ...options,
  });
